import { Head, Link, useForm } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { DashboardLayout } from '@/layouts/DashboardLayout'
import { fundsPath } from '@/lib/routes'

import { FundFormFields, type FundFormData } from './_Form'

function FundsNew() {
  const form = useForm<FundFormData>({
    name: '',
    slug: '',
    vintage_year: new Date().getFullYear(),
  })

  return (
    <>
      <Head title="New fund" />

      <div className="mx-auto max-w-3xl px-8 py-10">
        <Link
          href={fundsPath()}
          className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to funds
        </Link>

        <PageHeader title="New fund" description="Create a new investment vehicle." />

        <form
          onSubmit={(event) => {
            event.preventDefault()
            form.transform((data) => ({ fund: data }))
            form.post(fundsPath())
          }}
        >
          <FundFormFields
            data={form.data}
            errors={form.errors as Partial<Record<keyof FundFormData, string>>}
            setData={form.setData}
          />

          <div className="mt-6 flex justify-end gap-2">
            <Link href={fundsPath()}>
              <Button type="button" variant="ghost">
                Cancel
              </Button>
            </Link>
            <Button type="submit" disabled={form.processing}>
              {form.processing ? 'Saving…' : 'Create fund'}
            </Button>
          </div>
        </form>
      </div>
    </>
  )
}

export default Object.assign(FundsNew, {
  layout: (page: ReactNode) => <DashboardLayout>{page}</DashboardLayout>,
})
